import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getMe, login } from "@safers/api";
import { useAuthStore } from "@safers/auth";
import { goAfterLogin } from "@/lib/afterLogin";
import { SplitLogin } from "@safers/ui/organisms";
import { BrandLockup } from "@safers/ui/atoms";
import loginHero from "@safers/ui/assets/login-hero.webp";

export function LoginPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const setUser = useAuthStore((state) => state.setUser);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit({ username, password }: { username: string; password: string }) {
    if (!username || !password) {
      setError("아이디와 비밀번호를 입력해주세요.");
      return;
    }
    setError(null);
    setLoading(true);
    try {
      await login({ username, password });
      const user = await getMe();
      setUser(user);

      goAfterLogin({
        authority: user.authority,
        username: user.username,
        returnUrl: searchParams.get("returnUrl"),
        navigate,
      });
    } catch {
      setError("로그인에 실패했습니다. 아이디와 비밀번호를 확인해주세요.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <SplitLogin
      title="로그인"
      subtitle="현장 안전 관제 서비스에 접속합니다."
      brandName=""
      logo={<BrandLockup />}
      heroTitle={
        <>
          현장 안전을
          <br />
          실시간으로 지켜봅니다.
        </>
      }
      heroDescription="현장 3D, 실시간 CCTV, AI 이벤트 알림으로 안전 상황을 한눈에 모니터링합니다."
      heroImage={loginHero}
      footer="© Pluxity · SAFERS"
      helpText="계정 문의는 관리자에게 연락해주세요."
      loading={loading}
      error={error}
      onSubmit={handleSubmit}
    />
  );
}
